package one.healthium.profile.ui.food.models

import kotlinx.serialization.Serializable
import one.healthium.base.utils.toString
import one.healthium.insights.domain.models.MealNutritionModel

@Serializable
data class FoodUiModel(
    val emoji: String,
    val product: String,
    val description: String,
    val calories: Float,
    val fat: Float,
    val carbohydrates: Float,
    val fiber: Float,
    val protein: Float,
    val tablespoon: Float?,
    val cups: Float?,
    val pieces: Float?,
    val portion: Float?,
    val isLiquid: Boolean,
) {
    val displayName = "$emoji $product"

    fun caloriesPerUnitDisplayValue(isMetric: Boolean): String = if (isMetric) {
        "${calories.toString(2)} cal / ${Units.Gram.format(100f)}"
    } else {
        val calories = calories * Units.Oz.gramValue / 100
        "${calories.toString(2)} cal / ${Units.Oz.format(1f)}"
    }

    companion object {
        val preview = FoodUiModel(
            emoji = "🍎",
            product = "Apple with Cinnamon and Organic Peanut",
            description = "A delicious apple",
            calories = 52f,
            fat = 0.2f,
            carbohydrates = 14f,
            fiber = 2.4f,
            protein = 0.3f,
            tablespoon = null,
            cups = null,
            pieces = null,
            portion = null,
            isLiquid = false,
        )

        fun fromMealNutrition(meal: MealNutritionModel): FoodUiModel {
            return FoodUiModel(
                emoji = "🍽️",
                product = meal.product ?: "",
                description = "",
                calories = meal.calories ?: 0f,
                fat = meal.fat ?: 0f,
                carbohydrates = meal.carbs ?: 0f,
                fiber = meal.fiber ?: 0f,
                protein = meal.protein ?: 0f,
                tablespoon = null,
                cups = null,
                pieces = null,
                portion = meal.portion,
                isLiquid = false,
            )
        }
    }
}